//React
import React from "react"
import { useInView } from "react-cool-inview"
import { useNavigate } from "react-router-dom"

//Icons
import { faAdd } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

//Components
import MainContainer from "../../../Components/Containers/MainContainer"
import SideContainer from "../../../Components/Containers/SideContainer"
import InteractionList from "../Components/InteractionList"

export default function InteractionsHome({
  interactions,
  setPagination,
  pagination,
  showMore,
  listInteractions,
}) {
  const navigate = useNavigate()

  const { observe } = useInView({
    onEnter: () => {
      listInteractions()
    },
  })
  return (
    <div>
      <SideContainer classes={"d-xl-none"}>
        <InteractionList
          interactions={interactions}
          setPagination={setPagination}
          pagination={pagination}
        >
          {showMore && <div ref={observe} className="pb-5"></div>}
        </InteractionList>
      </SideContainer>
      <MainContainer
        classes={
          "d-none d-xl-flex justify-content-center align-items-center p-4"
        }
      >
        <div>
          Select a interaction or click
          <button
            className="btn btn-primary mx-2"
            onClick={() => navigate("./create_interaction")}
          >
            <FontAwesomeIcon icon={faAdd} />
          </button>
          to create a new interaction
        </div>
      </MainContainer>
    </div>
  )
}
